import { Subject } from "rxjs";

const subject = new Subject()

export const unAuthenticateService = {
  sendUnAuthenticate: () => subject.next({}),
  getUnAuthenticate: () => subject.asObservable(),
}

